/**
 * @generated SignedSource<<e5557b0eaec5d72eca603b2f5f16aa1c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WidgetIssueOverviewIssueItemToggleResolvedMutation$variables = {
  isResolved: boolean;
  issueId: string;
};
export type WidgetIssueOverviewIssueItemToggleResolvedMutation$data = {
  readonly issue: {
    readonly setResolved: {
      readonly issue: {
        readonly id: string;
        readonly resolved: boolean;
      };
    };
  };
};
export type WidgetIssueOverviewIssueItemToggleResolvedMutation$rawResponse = {
  readonly issue: {
    readonly setResolved: {
      readonly issue: {
        readonly id: string;
        readonly resolved: boolean;
      };
    };
  };
};
export type WidgetIssueOverviewIssueItemToggleResolvedMutation = {
  rawResponse: WidgetIssueOverviewIssueItemToggleResolvedMutation$rawResponse;
  response: WidgetIssueOverviewIssueItemToggleResolvedMutation$data;
  variables: WidgetIssueOverviewIssueItemToggleResolvedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isResolved"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "issueId"
      }
    ],
    "concreteType": "IssueMutation",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "isResolved",
            "variableName": "isResolved"
          }
        ],
        "concreteType": "SetResolvedIssuePayload",
        "kind": "LinkedField",
        "name": "setResolved",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resolved",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetIssueOverviewIssueItemToggleResolvedMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WidgetIssueOverviewIssueItemToggleResolvedMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7a036ab15cce18f169251235745b0a75",
    "id": null,
    "metadata": {},
    "name": "WidgetIssueOverviewIssueItemToggleResolvedMutation",
    "operationKind": "mutation",
    "text": "mutation WidgetIssueOverviewIssueItemToggleResolvedMutation(\n  $issueId: ID!\n  $isResolved: Boolean!\n) {\n  issue(id: $issueId) {\n    setResolved(isResolved: $isResolved) {\n      issue {\n        id\n        resolved\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "13dd60d4e11495ec82d0c5ea6b42e915";

export default node;
